import React from 'react'
export default function SearchBar({ value, onChange, onClear }:{ value: string; onChange: (v:string)=>void; onClear: ()=>void }){
  return (
    <div style={{display:'flex', gap:'.5rem', margin:'0 0 16px'}}>
      <input
        value={value}
        onChange={e=>onChange(e.target.value)}
        placeholder="Suche: Name, Place ID …"
        style={{flex:1, padding:'10px 12px', border:'1px solid #ddd', borderRadius:8}}
      />
      {value && <button onClick={onClear} aria-label="Clear search">X</button>}
    </div>
  )
}
